import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  SimpleGrid,
  Text,
  Textarea,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { v4 as uuidv4, v4 } from "uuid";
import { setModelApi } from "../../../allApi/api";
import { useDispatch } from "react-redux";
import { waveFlowModaladd } from "../../../redux/reducer/waveFlow";
import formatDate from "../models/DateSet";
import { AddIcon } from "@chakra-ui/icons";
import ToolForm from "./ToolsModalShown";

const models = [
  { name: "together", description: "together" },
  { name: "groq", description: "groq" },
  { name: "OpenAI", description: "openAI" },
  { name: "mistral", description: "mistral" },
];

function ToolsOpen() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isNameModalOpen,
    onOpen: onNameModalOpen,
    onClose: onNameModalClose,
  } = useDisclosure();

  const [selectedModel, setSelectedModel] = useState(null);
  const [formData, setFormData] = useState({
    // id: v4(),
    client: "",
    model_name: "",
    api_key: "",
    base_url: "",
    description: "",
    date: formatDate(new Date()),
  });

  const handleModelClick = (model) => {
    setSelectedModel(model);
    setFormData({
      ...formData,
      client: model.name,
      description: model.description,
    });
    onNameModalOpen();
  };

 

 
  return (
    <>
      <Flex justifyContent="flex-end" w="100%" >
        <Button
          rightIcon={<AddIcon />}
          size={"xs"}
          bgGradient="linear(to-r, purple.400, blue.500)"
          color="white"
          _hover={{
            bgGradient: "linear(to-r, purple.500, blue.600)",
            boxShadow: "md",
          }}
          borderRadius="md"
          px="2"
          py="1"
          onClick={onOpen}
          fontSize={"14px"}
        >
          New Tools
        </Button>
      </Flex>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent maxWidth="60%" h={"fit-content"}>
          <ModalCloseButton />
          <ModalBody>
            <ToolForm onClose={onClose} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ToolsOpen;
